<template>
    <el-card class="list-card">
        <div slot="header" class="card-header">
            <span class="header-title">{{cardHeader}}</span>
            <span class="header-line"></span>
        </div>

        <ul class="article-list">
            <li v-for="(a, index) in articles" :key="a.id" 
                @click="view(a.id)"
                class="article-item">
                <span class="item-number" :class="{ 'top-three': index < 3 }">{{index + 1}}</span>
                <a class="item-title">{{a.title}}</a>
            </li>
        </ul>
    </el-card>
</template>

<script>
    export default {
        name: 'ArticleCard',
        props: {
            cardHeader: {
                type: String,
                required: true
            },
            articles: {
                type: [],
                required: true
            },
            itemStyle: ""
        },
        data() {
            return {}
        },
        methods: {
            view(id) {
                this.$router.push({path: `/view/${id}`});
            }
        }
    }
</script>

<style scoped>
    /* 列表卡片 */
    .list-card :deep(.el-card__header) {
        padding: 20px 24px;
        border-bottom: none;
    }

    .list-card :deep(.el-card__body) {
        padding: 0 24px 20px !important;
    }

    .card-header {
        display: flex;
        align-items: center;
        gap: 12px;
    }

    .header-title {
        font-size: 15px;
        font-weight: 600;
        color: var(--text-primary);
        letter-spacing: 0.3px;
        white-space: nowrap;
    }

    .header-line {
        flex: 1;
        height: 1px;
        background: linear-gradient(90deg, var(--border-light) 0%, transparent 100%);
    }

    /* 文章列表 */
    .article-list {
        list-style: none;
        margin: 0;
        padding: 0;
    }

    .article-item {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        padding: 10px 0;
        cursor: pointer;
        border-bottom: 1px solid var(--bg-secondary);
        transition: all 0.2s ease;
    }

    .article-item:last-child {
        border-bottom: none;
    }

    .article-item:hover .item-title {
        color: var(--accent-warm);
    }

    /* 序号 */
    .item-number {
        flex-shrink: 0;
        width: 22px;
        height: 22px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 11px;
        font-weight: 600;
        color: var(--text-tertiary);
        background: var(--bg-secondary);
        border-radius: 4px;
    }

    .item-number.top-three {
        color: white;
        background: linear-gradient(135deg, var(--accent-warm) 0%, #c9956b 100%);
    }

    /* 标题 */
    .item-title {
        flex: 1;
        font-size: 13px;
        line-height: 1.6;
        color: var(--text-secondary);
        transition: color 0.2s ease;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
</style>
